import React from "react";
import Button from "components/CustomButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHourglassEnd } from "@fortawesome/free-solid-svg-icons";

var styles = {
  progressOverlay: {
    position: "absolute",
    width: "100%",
    height: "100%",
    top: "0",
    left: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    flexDirection: "column",
  },
  hourGlassButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
  },
};

export default ({
  isSubmitting = false,
  fontSize,
  isValid = true,
  progress = 100,
  color = "warning",
  initialText = "Send",
  message = "Creating post",
  uploadMessage = "Uploading",
  buttonWithProgressClass = {},
  style = {},
  overlay = true,
  iconfontSize = "20px",
  onClick = () => {},
  type = "submit",
}) => {
  const classes = styles;
  return (
    <>
      <Button
        type={type}
        disabled={isSubmitting || !isValid}
        color={color}
        buttonStyle={style}
        onClick={onClick}
        buttonClass={buttonWithProgressClass}
      >
        <div style={classes.hourGlassButton}>
          {!isSubmitting && <span>{initialText}</span>}
          {isSubmitting && (
            <span
              className="material-icons"
              style={{ padding: "0 10px", fontSize: iconfontSize }}
            >
              <FontAwesomeIcon icon={faHourglassEnd} />
            </span>
          )}
          {isSubmitting && progress === 100 && <span>{message}</span>}
          {isSubmitting && progress !== 100 && (
            <span>
              {uploadMessage} {progress}
            </span>
          )}
        </div>
      </Button>
      {isSubmitting && overlay && <div style={classes.progressOverlay}></div>}
    </>
  );
};
